import { render } from "./NavigationDrawer.vue?vue&type=template&id=84715ae2&scoped=true"
import script from "./NavigationDrawer.vue?vue&type=script&lang=js"
export * from "./NavigationDrawer.vue?vue&type=script&lang=js"

import "./NavigationDrawer.vue?vue&type=style&index=0&id=84715ae2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84715ae2"]])

export default __exports__